import styled from 'styled-components';
import {BorderRadius, colors, GridContainerEdge, mediaQueries} from '@theme/lib';
import { isBicentenary } from '@/lib/utils';
import { getGridContainerEdgeStyling } from '@components/BicentenaryPatterns/BicentenaryPatterns.styles';

export const StyledTextAndImage = styled('div')<{ layout: string }>`
  display: grid;
  grid-template-columns: repeat(5, [col-start] 1fr);
  gap: 1rem;
  color: ${(props) => props.theme.colors.text};
  ${(props) => isBicentenary(props.theme.key) ? `background-color: ${colors.seagrass};` : ''};
  ${mediaQueries.md} {
    grid-template-columns: repeat(8, [col-start] 1fr);
    gap: 2rem;
  }
`;

export const StyledText = styled('div')<{ layout: string }>`
  grid-column: 1 / span 5;
  justify-self: center;
  ${mediaQueries.md} {
    align-self: center;
    margin-right: ${(props) => props.layout ==='text_image' ? '3.5rem': undefined};
    margin-left: ${(props) => props.layout ==='image_text' ? '3.5rem': undefined};
    grid-column: ${(props) => props.layout ==='text_image' ? '1 / span 4': '5 / span 4'};
  }
  h2 {
    @include h2;
    margin-bottom: 1.25rem;
    ${mediaQueries.md} {
      font-size: 2.5rem;
      margin-bottom: 2rem;
    }
    color: ${(props) => props.theme.colors.text};
  }
  a {
    margin-top: 1.5rem;
    ${(props) => isBicentenary(props.theme.key) ? `color: ${colors.white}` : ''};
    ${mediaQueries.md} {
      margin-top: 2rem;
    }
  }
  h2,
  > div {
    color: ${(props) => isBicentenary(props.theme.key) ? colors.white : props.theme.colors.text};
  }
  > a {
    ${(props) => isBicentenary(props.theme.key) ? `
      background-color: ${colors.honeyBee};
      color: ${colors.black};
      &:hover {
        background-color: ${colors.white};
        color: ${colors.black};
      }
    ` : ''}
  }
`;

export const TextImageGridContainerEdge = styled(GridContainerEdge)`
  padding-top: 2rem;
  padding-bottom: 2rem;
  margin-bottom: 3rem;
  ${mediaQueries.md} {
    margin-bottom: 4rem;
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  & + & {
    padding-top: 0;
    margin-top: -1rem;
    ${mediaQueries.md} {
      padding-top: 0;
      margin-top: -2rem;
    }
  }
  ${(props) => getGridContainerEdgeStyling({ ...props, background: 'seagrass' })}
`;

export const StyledImage = styled('div')<{ layout: string }>`
  grid-column: 1 / span 5;
  img {
    ${props => BorderRadius(props.theme.config.imageBorderRadius.mobile)};
    overflow: hidden;
    width: 100%;

    ${mediaQueries.md} {
      ${props => BorderRadius(props.theme.config.imageBorderRadius.desktop)};
    }
  }
  margin-bottom: 1rem;
  justify-self: center;
  ${mediaQueries.md} {
    margin-bottom: 0;
    align-self: center;
    grid-column: ${(props) => props.layout ==='text_image' ? '5 / span 4': '1 / span 4'};
  }
  .caption {
    color: ${(props) => isBicentenary(props.theme.key) ? colors.white : props.theme.colors.text};
    display: block;
    margin-top: 0.5rem;
  }
`;

